class SiteInfo {
  name = '';

  constructor(name) {
    this.name = name;
  }
}

export default SiteInfo;
